import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';

import { Section } from '@models/section/section';

import { HttpService } from '@services/http.service';
import { HttpParams } from '@angular/common/http';
import { SectionsBuilders } from '@models/section/sections-builder';
import { EndpointParams } from '@models/utils/endpoint-params';

@Injectable({
    providedIn: 'root'
})
export class SectionsService extends HttpService {
    private readonly defaultEndpointParams: EndpointParams = { app: 'center', version: 1 };

    private sectionsSubject = new BehaviorSubject<Section[]>([]);
    private isLoadingSubject = new BehaviorSubject<boolean>(true);
    private dataStore: { sections: Section[] } = { sections: [] };

    readonly sections = this.sectionsSubject.asObservable();
    readonly isLoading = this.isLoadingSubject.asObservable();

    list(publicToken: string): void {
        this.loading(true);
        this.listSections(publicToken).subscribe(
            () => {
                this.next();
                this.loading(false);
            }
        );
    }

    private listSections(publicToken: string): Observable<boolean> {
        return new Observable<boolean>(
            observable => {
                const params = new HttpParams({ fromString: `centerToken=${publicToken}` });
                this.get('polaris/webpage/sections/center', this.defaultEndpointParams, params).subscribe(
                    data => {
                        this.dataStore.sections = [];
                        data.forEach((section: any) => {
                            this.dataStore.sections.push(SectionsBuilders.buildSection(section));
                        });

                        observable.next(true);
                    }, () => observable.next(false)
                );
            }
        );
    }

    private next(): void {
        this.sectionsSubject.next([ ...this.dataStore.sections ]);
    }

    private loading(value: boolean): void {
        this.isLoadingSubject.next(value);
    }
}
